import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Label} from '../model/Label';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class LabelService extends CommonService<Label> {
  constructor(http: HttpClient) {
    super(http, '/label');
  }
}
